import { borderWidths, borderStyles } from '../borders.js';
import { radii } from '../radius.js';
import { sizes } from '../sizing.js';
import { colors } from '../colors.js';
import { opacity } from '../opacity.js';
export const baseInput = {
    minHeight: sizes.x8,
    borderWidth: borderWidths.sm,
    borderStyle: borderStyles.solid,
    borderRadius: radii.x1_5,
};
export const inputStates = {
    inactive: {
        color: colors.text.default,
        backgroundColor: colors.controls.secondary,
        borderColor: colors.transparent,
        placeholder: colors.forms.placeholder,
        placeholderActive: colors.forms.placeholderActive,
        placeholderOnGray: colors.forms.placeholderOnGray,
        iconColor: colors.forms.placeholder,
        actionColor: colors.text.default,
    },
    hover: {
        color: colors.text.default,
        backgroundColor: colors.controls.secondaryHover,
        borderColor: colors.transparent,
        placeholder: colors.forms.placeholder,
        placeholderActive: colors.forms.placeholderActive,
        placeholderOnGray: colors.forms.placeholderOnGray,
        iconColor: colors.forms.placeholder,
        actionColor: colors.text.secondary,
    },
    active: {
        color: colors.text.default,
        backgroundColor: colors.controls.white,
        borderColor: colors.borders.primary,
        placeholder: colors.forms.placeholder,
        placeholderActive: colors.forms.placeholderActive,
        placeholderOnGray: colors.forms.placeholderOnGray,
        iconColor: colors.forms.placeholder,
        actionColor: colors.text.default,
    },
    error: {
        color: colors.text.default,
        backgroundColor: colors.controls.secondary,
        borderColor: colors.borders.error,
        placeholder: colors.forms.placeholder,
        placeholderActive: colors.forms.placeholderActive,
        placeholderOnGray: colors.forms.placeholderOnGray,
        iconColor: colors.forms.placeholder,
        actionColor: colors.text.default,
    },
    disabled: {
        color: colors.text.default,
        backgroundColor: colors.controls.secondary,
        borderColor: colors.transparent,
        placeholder: colors.forms.placeholder,
        placeholderActive: colors.forms.placeholderActive,
        placeholderOnGray: colors.forms.placeholderOnGray,
        iconColor: colors.forms.placeholder,
        actionColor: colors.text.default,
        opacity: opacity.disabled,
    },
};
//# sourceMappingURL=inputs.js.map